<ng-template #resultRow let-poi="poi">
  <img
    class="ml-2 mr-2"
    src="{{ 'images/flags/country_' + poi.country_code.toLowerCase() + '.svg' | platformasset: true }}" />
  <div class="d-flex w-100 flex-column">
    <div class="name" [innerHTML]="poi.name | highlight: poiFormControl.value"></div>
    @if (poi.region && poi.province) {
      <div class="info d-flex align-items-end">
        {{ poi.region }}, {{ poi.province }}
        @if (poi.entity_count && platform !== 'es') {
          <span class="count ml-auto pl-1 flex-shrink-0"
            >{{
              'ALPINSKIHIRE.shopSearch.formSearchResultShopNumber'
                | alpitranslate: { count: poi.entity_count > 30 ? 30 : poi.entity_count }
            }}
          </span>
        }
      </div>
    }
  </div>
</ng-template>

<ng-container [formGroup]="poiFormGroup">
  <div #poiSearch>
    <div
      class="form-line-normal form-placeholder form-placeholder-narrow"
      [class.mb-0]="shopSearchHelper.formMinified">
      <input
        placeholder=" "
        class="form-input form-input-icon-left"
        [class.c-not-allowed]="disableSearch"
        #poiInput
        type="text"
        formControlName="poi"
        autocomplete="{{ isChrome ? 'off' : 'on' }}"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="false"
        (input)="searchPoi($any($event.target).value)"
        (blur)="onPoiSearch = false"
        (focus)="showResults(); onPoiSearch = true"
        (mouseup)="$any($event.target).select()"
        name="poi[random_to_avoid_autocomplete123456]"
        id="searchform_value" />
      @if (poiFormControl.valid || (!poiFormControl.dirty && !poiFormControl.touched)) {
        <label class="form-label" for="searchform_value">
          {{ 'ALPINSKIHIRE.shopSearch.formSearchLabel' | alpitranslate }}
        </label>
      }
      @if (poiFormControl.invalid && (poiFormControl.dirty || poiFormControl.touched)) {
        <label class="form-label text-error" for="searchform_value">
          {{ 'ALPINSKIHIRE.shopSearch.validation.enterTown' | alpitranslate }}
        </label>
      }
      <div class="form-icon text-danger">
        @if (!nowSearching) {
          <app-icon name="place" width="25px" height="25px" />
        }
        @if (nowSearching) {
          <div class="spinner-border" role="status"></div>
        }
      </div>
    </div>
    @if (shopSearchHelper.formMinified) {
      <div class="search-mobile-panel d-flex d-lg-none flex-row justify-content-left align-items-center py-2">
        <div class="search-mobile-body">
          <div class="search-mobile-details">
            <span class="mr-3 d-inline-block">
              {{
                'ALPINSKIHIRE.shopSearch.minified.date'
                  | alpitranslate
                    : {
                        start_date:
                          bookingParameters.start
                          | date
                            : ('ALPINSKIHIRE.shopSearch.minified.dateFormat' | alpitranslate)
                            : null
                            : translateService.currentLang,
                        end_date:
                          bookingParameters.end
                          | date
                            : ('ALPINSKIHIRE.shopSearch.minified.dateFormat' | alpitranslate)
                            : null
                            : translateService.currentLang
                      }
              }}
            </span>
            <span class="mr-1 text-nowrap">
              {{
                'ALPINSKIHIRE.shopSearch.minified.users'
                  | alpitranslate
                    : {
                        number_adults: bookingParameters.getNumberOfAdults(),
                        number_children: bookingParameters.getNumberOfChildren()
                      }
              }}
            </span>
          </div>
        </div>
      </div>
    }
    @if (displayResults) {
      <div class="locations">
        <!-- now searching... -->
        <!-- no results found! -->
        @if (pois.length < 1 && similar.length < 1 && nowSearching === false) {
          <div class="text-center">
            <span class="result-right-panel">
              <span class="d-flex align-items-center justify-content-center" data-height="30">
                <app-icon name="alarm" class="m-2" />{{
                  'ALPINSKIHIRE.shopSearch.noResults' | alpitranslate
                }}</span
              >
            </span>
          </div>
        }
        <!-- the results, grouped by type -->
        @if (locationResults.length) {
          <div class="d-flex align-items-center justify-content-left mt-2 header">
            <app-icon name="locationPin" class="m-2 ml-3" />
            <h1>{{ 'ALPINSKIHIRE.shopSearch.formSearchResultGroupLocations' | alpitranslate }}</h1>
          </div>
          @for (poi of locationResults; track poi; let i = $index) {
            <div
              data-test="locationSearchResults"
              (click)="selectPoi(poi)"
              class="d-flex align-items-center result-group px-2 py-2"
              [class.selected]="selected === i"
              [class.disabled]="nowSearching">
              <ng-container *ngTemplateOutlet="resultRow; context: { poi: poi }"></ng-container>
            </div>
          }
        }
        @if (shopResults.length) {
          <div class="d-flex align-items-center justify-content-left mt-4 header">
            <app-icon name="shopPin" class="m-2 ml-3" />
            <h1>{{ 'ALPINSKIHIRE.shopSearch.formSearchResultGroupShops' | alpitranslate }}</h1>
          </div>
          @for (poi of shopResults; track poi; let i = $index) {
            <div
              data-test="shopSearchResults"
              (click)="selectPoi(poi)"
              class="d-flex align-items-center result-group px-2 py-2"
              [class.selected]="selected === i + locationResults.length"
              [class.disabled]="nowSearching">
              <ng-container *ngTemplateOutlet="resultRow; context: { poi: poi }"></ng-container>
            </div>
          }
        }
        @if (regionResults.length) {
          <div class="d-flex align-items-center justify-content-left mt-4 header">
            <app-icon name="smMap" class="m-2 ml-3" />
            <h1>{{ 'ALPINSKIHIRE.shopSearch.formSearchResultGroupRegions' | alpitranslate }}</h1>
          </div>
          @for (poi of regionResults; track poi; let i = $index) {
            <div
              data-test="regionSearchResults"
              (click)="selectPoi(poi)"
              class="d-flex align-items-center result-group px-2 py-2"
              [class.selected]="selected === i + locationResults.length + shopResults.length"
              [class.disabled]="nowSearching">
              <ng-container *ngTemplateOutlet="resultRow; context: { poi: poi }"></ng-container>
            </div>
          }
        }
        @if (countryResults.length) {
          <div class="d-flex align-items-center justify-content-left mt-4 header">
            <app-icon name="worldPin" class="m-2 ml-3" />
            <h1>{{ 'ALPINSKIHIRE.shopSearch.formSearchResultGroupCountries' | alpitranslate }}</h1>
          </div>
          @for (poi of countryResults; track poi; let i = $index) {
            <div
              data-test="countrySearchResults"
              (click)="selectPoi(poi)"
              class="d-flex align-items-center result-group px-2 py-2"
              [class.selected]="
                selected === i + locationResults.length + shopResults.length + regionResults.length
              "
              [class.disabled]="nowSearching">
              <ng-container *ngTemplateOutlet="resultRow; context: { poi: poi }"></ng-container>
            </div>
          }
        }
      </div>
    }
  </div>
</ng-container>
